//@flow

import React from 'react';
import i18n from 'app/common/lib/i18n';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';
import { Box, Heading, IconButton, Text } from 'gestalt';

type Props = {|
  handleComplete: () => void,
  topicName?: string,
  negativeResponse?: boolean,
|};

const contentBorderStyle = {
  borderRadius: 16,
  paddingTop: 8,
  paddingBottom: 28,
  paddingLeft: 20,
  paddingRight: 20,
};

function getModalText(negativeResponse: boolean, topicName: string) {
  if (negativeResponse) {
    return interpolateNamedTemplate(
      i18n._(
        'We will stop sending you emails about {{ topicName }} and use this information to improve the quality of your recommendations via email in the future.',
        'Negative feedback message',
      ),
      { topicName },
    );
  } else {
    return i18n._(
      'This will help us improve the quality of your recommendations via email in the future.',
      'Positive feedback message',
    );
  }
}

export default function EmailFeedbackModal(props: Props) {
  const { handleComplete = () => {}, topicName = '', negativeResponse = false } = props;
  return (
    <Box
      display="flex"
      direction="column"
      color="white"
      overflow="hidden"
      shape="rounded"
      padding={4}
      width={650}
    >
      <Box alignSelf="end" display="flex">
        <IconButton
          accessibilityLabel={i18n._('Close', 'accessible label for close button')}
          iconColor="gray"
          icon="cancel"
          onClick={() => handleComplete()}
          size="xl"
        />
      </Box>
      <div style={contentBorderStyle}>
        <Box display="flex">
          <Heading size="sm">
            {i18n._('Thanks for your feedback', 'Header for email feedback landing experience')}
          </Heading>
        </Box>
        <Box paddingY={4}>
          <Text overflow="normal" size="lg">
            {getModalText(negativeResponse, topicName)}
          </Text>
        </Box>
      </div>
    </Box>
  );
}
